import { SorterResult } from 'antd/es/table/interface';
import { Town, TownFilterParams } from '@/types/admin-town';
import { AppBreadcrumb, AppContainer, AppPagination } from '../atoms';
import { TownTable } from '../molecules';
import { AdminTownFilter } from '../organisms';
import { BreadcrumbItemType } from 'antd/es/breadcrumb/Breadcrumb';

interface AdminTownListTemplateProps {
  data: Town[];
  current: number;
  total: number;
  pageSize: number;
  sortInfo?: {
    columnKey?: string;
    order?: 'ascend' | 'descend';
  };
  onChange: (page: number) => void;
  onTableChange?: (sorter: SorterResult<Town> | SorterResult<Town>[]) => void;
  onSearch?: (filters: TownFilterParams) => void;
  onCsvDownload?: () => void;
  isCsvDownloading?: boolean;
  onCsvImport?: (file: File) => void;
  isCsvImporting?: boolean;
  breadcrumbItems: BreadcrumbItemType[];
  isLoading?: boolean;
}

const AdminTownListTemplate = ({
  data,
  isLoading,
  current,
  total,
  pageSize,
  sortInfo,
  onChange,
  onTableChange,
  onSearch,
  onCsvDownload,
  isCsvDownloading,
  onCsvImport,
  isCsvImporting,
  breadcrumbItems,
}: AdminTownListTemplateProps) => {
  return (
    <AppContainer>
      <main className="space-y-5 px-4">
        <AppBreadcrumb items={breadcrumbItems} />
        <h3 className="text-xl">郵便番号</h3>
        <AdminTownFilter
          onSearch={onSearch}
          onCsvDownload={onCsvDownload}
          isCsvDownloading={isCsvDownloading}
          onCsvImport={onCsvImport}
          isCsvImporting={isCsvImporting}
        />

        <div className="bg-white rounded-md border">
          <TownTable
            data={data}
            sortInfo={sortInfo}
            onTableChange={onTableChange}
            isLoading={isLoading}
          />
          <div className="flex justify-end p-4">
            <AppPagination
              current={current}
              total={total}
              pageSize={pageSize}
              onChange={onChange}
            />
          </div>
        </div>
      </main>
    </AppContainer>
  );
};

export default AdminTownListTemplate;
